module.exports = "<app-display-unit #displayunit></app-display-unit>\r\n"